import { render, staticRenderFns } from "./onPremDialog.vue?vue&type=template&id=4a1bd931&scoped=true&"
import script from "./onPremDialog.vue?vue&type=script&lang=tsx&"
export * from "./onPremDialog.vue?vue&type=script&lang=tsx&"
import style0 from "./onPremDialog.vue?vue&type=style&index=0&id=4a1bd931&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1bd931",
  null
  
)

export default component.exports